/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "common/v3/generic/device.proto" (package "fubo.tv.proto.common.v3.generic", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { DeviceType_DeviceTypeValue } from "./common_enums";
import { DeviceCategory_DeviceCategoryValue } from "./common_enums";
/**
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.Device
 */
export interface Device {
    /**
     * @generated from protobuf field: fubo.tv.proto.common.v3.generic.DeviceCategory.DeviceCategoryValue device_category = 1;
     */
    device_category: DeviceCategory_DeviceCategoryValue;
    /**
     * @generated from protobuf field: fubo.tv.proto.common.v3.generic.DeviceType.DeviceTypeValue device_type = 2;
     */
    device_type: DeviceType_DeviceTypeValue;
    /**
     * @generated from protobuf field: string user_agent = 3;
     */
    user_agent: string;
    /**
     * @generated from protobuf field: optional string os = 4;
     */
    os?: string;
    /**
     * @generated from protobuf field: optional string os_version = 5;
     */
    os_version?: string;
    /**
     * @generated from protobuf field: optional string browser = 6;
     */
    browser?: string;
    /**
     * @generated from protobuf field: optional string browser_version = 7;
     */
    browser_version?: string;
    /**
     * @generated from protobuf field: optional string browser_engine = 8;
     */
    browser_engine?: string;
    /**
     * @generated from protobuf field: optional string browser_engine_version = 9;
     */
    browser_engine_version?: string;
    /**
     * @generated from protobuf field: string device_id = 10;
     */
    device_id: string;
    /**
     * @generated from protobuf field: string device_manufacturer = 11;
     */
    device_manufacturer: string;
    /**
     * @generated from protobuf field: string device_model = 12;
     */
    device_model: string;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Device.InputMode input_mode = 13;
     */
    input_mode?: Device_InputMode;
    /**
     * @generated from protobuf field: optional string runtime = 14;
     */
    runtime?: string;
    /**
     * @generated from protobuf field: optional int64 screen_height = 15;
     */
    screen_height?: string;
    /**
     * @generated from protobuf field: optional int64 screen_width = 16;
     */
    screen_width?: string;
    /**
     * @generated from protobuf field: optional string advertising_id = 17;
     */
    advertising_id?: string;
    /**
     * @generated from protobuf field: optional string device_name = 18;
     */
    device_name?: string;
    /**
     * @generated from protobuf field: optional string device_brand = 19;
     */
    device_brand?: string;
    /**
     * @generated from protobuf field: optional string appsflyer_device_id = 20;
     */
    appsflyer_device_id?: string;
    /**
     * @generated from protobuf field: optional bool limit_ad_tracking = 21;
     */
    limit_ad_tracking?: boolean;
    /**
     * @generated from protobuf field: optional string remote_type = 22;
     */
    remote_type?: string;
}
/**
 * @generated from protobuf enum fubo.tv.proto.common.v3.generic.Device.InputMode
 */
export enum Device_InputMode {
    /**
     * @generated from protobuf enum value: unknown_input_mode = 0;
     */
    unknown_input_mode = 0,
    /**
     * @generated from protobuf enum value: mouse = 1;
     */
    mouse = 1,
    /**
     * @generated from protobuf enum value: remote = 2;
     */
    remote = 2,
    /**
     * @generated from protobuf enum value: touch = 3;
     */
    touch = 3,
    /**
     * @generated from protobuf enum value: voice = 4;
     */
    voice = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class Device$Type extends MessageType<Device> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.Device", [
            { no: 1, name: "device_category", kind: "enum", localName: "device_category", T: () => ["fubo.tv.proto.common.v3.generic.DeviceCategory.DeviceCategoryValue", DeviceCategory_DeviceCategoryValue], options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "fire_tv", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Device Category." } },
            { no: 2, name: "device_type", kind: "enum", localName: "device_type", T: () => ["fubo.tv.proto.common.v3.generic.DeviceType.DeviceTypeValue", DeviceType_DeviceTypeValue], options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "puck", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Device Type." } },
            { no: 3, name: "user_agent", kind: "scalar", localName: "user_agent", T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "Mozilla/5.0 (X11; Linux armv7l) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/63.0.3239.58 Safari/537.36 CrKey/1.29.104827", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "User-Agent." } },
            { no: 4, name: "os", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "Windows", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Os Name." } },
            { no: 5, name: "os_version", kind: "scalar", localName: "os_version", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "15.3", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Os Version." } },
            { no: 6, name: "browser", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "Mozilla", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Browser." } },
            { no: 7, name: "browser_version", kind: "scalar", localName: "browser_version", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "9.23.3", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Browser Version." } },
            { no: 8, name: "browser_engine", kind: "scalar", localName: "browser_engine", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "Webkit", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Browser Engine." } },
            { no: 9, name: "browser_engine_version", kind: "scalar", localName: "browser_engine_version", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "9.23.3", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Browser Engine Version." } },
            { no: 10, name: "device_id", kind: "scalar", localName: "device_id", T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "bfd8a560-4471-5eb5-a594-75a6bccc9225", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "ID that identifies the device." } },
            { no: 11, name: "device_manufacturer", kind: "scalar", localName: "device_manufacturer", T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "Samsung", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Device Manufacturer." } },
            { no: 12, name: "device_model", kind: "scalar", localName: "device_model", T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "SM-G955U", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Device Model." } },
            { no: 13, name: "input_mode", kind: "enum", localName: "input_mode", opt: true, T: () => ["fubo.tv.proto.common.v3.generic.Device.InputMode", Device_InputMode], options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "Mouse", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "How the user use his device." } },
            { no: 14, name: "runtime", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "EP044586290014_10387_2022-11-29T19:00:00Z_2022-11-29T21:00:00Z", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Runtime." } },
            { no: 15, name: "screen_height", kind: "scalar", localName: "screen_height", opt: true, T: 3 /*ScalarType.INT64*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "1080", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Screen Height (px)." } },
            { no: 16, name: "screen_width", kind: "scalar", localName: "screen_width", opt: true, T: 3 /*ScalarType.INT64*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "1920", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Screen Width (px)." } },
            { no: 17, name: "advertising_id", kind: "scalar", localName: "advertising_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "0DFD0C7A-09E3-4E51-BC81-747FF63F2951", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Advertising ID." } },
            { no: 18, name: "device_name", kind: "scalar", localName: "device_name", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "Roku Express", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Device Name." } },
            { no: 19, name: "device_brand", kind: "scalar", localName: "device_brand", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "Samsung", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Device Brand." } },
            { no: 20, name: "appsflyer_device_id", kind: "scalar", localName: "appsflyer_device_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "abcd-1234-efgh-5678", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "A device specific advertising ID used by appsflyer integration to perform attribution for fubo ad campaigns" } },
            { no: 21, name: "limit_ad_tracking", kind: "scalar", localName: "limit_ad_tracking", opt: true, T: 8 /*ScalarType.BOOL*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "false", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "If true, notifies appsflyer integration to ignore this device for attribution" } },
            { no: 22, name: "remote_type", kind: "scalar", localName: "remote_type", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "Siri Remote 1st Gen", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "A remote type used to control a device" } }
        ]);
    }
    create(value?: PartialMessage<Device>): Device {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.device_category = 0;
        message.device_type = 0;
        message.user_agent = "";
        message.device_id = "";
        message.device_manufacturer = "";
        message.device_model = "";
        if (value !== undefined)
            reflectionMergePartial<Device>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Device): Device {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* fubo.tv.proto.common.v3.generic.DeviceCategory.DeviceCategoryValue device_category */ 1:
                    message.device_category = reader.int32();
                    break;
                case /* fubo.tv.proto.common.v3.generic.DeviceType.DeviceTypeValue device_type */ 2:
                    message.device_type = reader.int32();
                    break;
                case /* string user_agent */ 3:
                    message.user_agent = reader.string();
                    break;
                case /* optional string os */ 4:
                    message.os = reader.string();
                    break;
                case /* optional string os_version */ 5:
                    message.os_version = reader.string();
                    break;
                case /* optional string browser */ 6:
                    message.browser = reader.string();
                    break;
                case /* optional string browser_version */ 7:
                    message.browser_version = reader.string();
                    break;
                case /* optional string browser_engine */ 8:
                    message.browser_engine = reader.string();
                    break;
                case /* optional string browser_engine_version */ 9:
                    message.browser_engine_version = reader.string();
                    break;
                case /* string device_id */ 10:
                    message.device_id = reader.string();
                    break;
                case /* string device_manufacturer */ 11:
                    message.device_manufacturer = reader.string();
                    break;
                case /* string device_model */ 12:
                    message.device_model = reader.string();
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Device.InputMode input_mode */ 13:
                    message.input_mode = reader.int32();
                    break;
                case /* optional string runtime */ 14:
                    message.runtime = reader.string();
                    break;
                case /* optional int64 screen_height */ 15:
                    message.screen_height = reader.int64().toString();
                    break;
                case /* optional int64 screen_width */ 16:
                    message.screen_width = reader.int64().toString();
                    break;
                case /* optional string advertising_id */ 17:
                    message.advertising_id = reader.string();
                    break;
                case /* optional string device_name */ 18:
                    message.device_name = reader.string();
                    break;
                case /* optional string device_brand */ 19:
                    message.device_brand = reader.string();
                    break;
                case /* optional string appsflyer_device_id */ 20:
                    message.appsflyer_device_id = reader.string();
                    break;
                case /* optional bool limit_ad_tracking */ 21:
                    message.limit_ad_tracking = reader.bool();
                    break;
                case /* optional string remote_type */ 22:
                    message.remote_type = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Device, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* fubo.tv.proto.common.v3.generic.DeviceCategory.DeviceCategoryValue device_category = 1; */
        if (message.device_category !== 0)
            writer.tag(1, WireType.Varint).int32(message.device_category);
        /* fubo.tv.proto.common.v3.generic.DeviceType.DeviceTypeValue device_type = 2; */
        if (message.device_type !== 0)
            writer.tag(2, WireType.Varint).int32(message.device_type);
        /* string user_agent = 3; */
        if (message.user_agent !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.user_agent);
        /* optional string os = 4; */
        if (message.os !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.os);
        /* optional string os_version = 5; */
        if (message.os_version !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.os_version);
        /* optional string browser = 6; */
        if (message.browser !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.browser);
        /* optional string browser_version = 7; */
        if (message.browser_version !== undefined)
            writer.tag(7, WireType.LengthDelimited).string(message.browser_version);
        /* optional string browser_engine = 8; */
        if (message.browser_engine !== undefined)
            writer.tag(8, WireType.LengthDelimited).string(message.browser_engine);
        /* optional string browser_engine_version = 9; */
        if (message.browser_engine_version !== undefined)
            writer.tag(9, WireType.LengthDelimited).string(message.browser_engine_version);
        /* string device_id = 10; */
        if (message.device_id !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.device_id);
        /* string device_manufacturer = 11; */
        if (message.device_manufacturer !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.device_manufacturer);
        /* string device_model = 12; */
        if (message.device_model !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.device_model);
        /* optional fubo.tv.proto.common.v3.generic.Device.InputMode input_mode = 13; */
        if (message.input_mode !== undefined)
            writer.tag(13, WireType.Varint).int32(message.input_mode);
        /* optional string runtime = 14; */
        if (message.runtime !== undefined)
            writer.tag(14, WireType.LengthDelimited).string(message.runtime);
        /* optional int64 screen_height = 15; */
        if (message.screen_height !== undefined)
            writer.tag(15, WireType.Varint).int64(message.screen_height);
        /* optional int64 screen_width = 16; */
        if (message.screen_width !== undefined)
            writer.tag(16, WireType.Varint).int64(message.screen_width);
        /* optional string advertising_id = 17; */
        if (message.advertising_id !== undefined)
            writer.tag(17, WireType.LengthDelimited).string(message.advertising_id);
        /* optional string device_name = 18; */
        if (message.device_name !== undefined)
            writer.tag(18, WireType.LengthDelimited).string(message.device_name);
        /* optional string device_brand = 19; */
        if (message.device_brand !== undefined)
            writer.tag(19, WireType.LengthDelimited).string(message.device_brand);
        /* optional string appsflyer_device_id = 20; */
        if (message.appsflyer_device_id !== undefined)
            writer.tag(20, WireType.LengthDelimited).string(message.appsflyer_device_id);
        /* optional bool limit_ad_tracking = 21; */
        if (message.limit_ad_tracking !== undefined)
            writer.tag(21, WireType.Varint).bool(message.limit_ad_tracking);
        /* optional string remote_type = 22; */
        if (message.remote_type !== undefined)
            writer.tag(22, WireType.LengthDelimited).string(message.remote_type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.Device
 */
export const Device = new Device$Type();
